import type { Translations } from './zh';

export const de: Translations = {
  bubble: {
    open: 'Chat öffnen',
    close: 'Chat schließen',
    badge: 'Online',
    dragHint: 'Zum Verschieben gedrückt halten',
  },
  panel: {
    closeAria: 'Chat-Fenster schließen',
    languageAria: 'Sprache auswählen',
    welcomeFallback: 'Hallo, wie kann ich Ihnen helfen?',
    quickQuestionsTitle: 'Sie können mich Folgendes fragen',
    quickAskTitle: 'Schnellfragen',
    inputPlaceholder: 'Geben Sie Ihre Frage ein...',
    sendButton: 'Senden',
    sendAria: 'Nachricht senden',
    onlineStatus: 'Online',
    thinkingAria: 'Denkt nach',
    aiBusyHint: 'Der Kundendienst antwortet gerade, bitte warten…',
    leadReopenHint: 'Bei Bedarf hier Ihre Kontaktdaten hinterlassen',
    startChat: 'Jetzt beraten lassen',
    welcomeQuickHint: 'Schnellüberblick',
    videoPreparing: 'Video wird vorbereitet…',
    newMessageTitle: '💬 Neue Nachricht',
    newMessageBody: 'Sie haben eine neue Nachricht. Klicken Sie hier, um sie zu lesen.',
  },
  roles: {
    visitor: 'Besucher',
    ai: 'KI-Assistent',
    human: 'Mitarbeiter',
    system: 'System',
  },
  web: {
    aiChat: 'KI-Support',
    humanChat: 'Mitarbeiter',
    switchToHuman: 'Mitarbeiter wählen',
    switchToAI: 'Zurück zur KI',
    resetChat: 'Chat neu starten',
    commonQuestions: 'Häufige Fragen',
    faqTitle: 'Häufig gestellte Fragen',
    selectLanguage: 'Sprache wählen',
    maximize: 'Maximieren',
    restore: 'Wiederherstellen',
    offlineLabel: 'Offline',
    aiGreeting: 'Hallo! Ich bin Ihr KI-Assistent. Wie kann ich Ihnen heute helfen?',
    humanGreeting: 'Hallo, Sie sind jetzt mit einem Mitarbeiter verbunden. Wie kann ich Ihnen helfen?',
    agentOffline: 'Mitarbeiter offline',
    agentOfflineMessage: 'Leider sind unsere Mitarbeiter derzeit offline. Bitte scannen Sie den QR-Code unten, um uns auf WeChat zu kontaktieren.',
    wechatPrompt: 'Scannen für WeChat',
    wechatHint: 'Scannen Sie mit WeChat, um unseren Support hinzuzufügen',
    serviceHoursLabel: 'Servicezeiten: ',
    viewImage: 'Bild ansehen',
    playVideo: 'Video abspielen',
    closeViewer: 'Schließen',
    downloadFile: 'Herunterladen',
    fileTypePdf: 'PDF-Dokument',
    fileTypeWord: 'Word-Dokument',
    fileTypeExcel: 'Excel-Tabelle',
    fileTypePpt: 'PowerPoint-Präsentation',
    fileTypeArchive: 'Archivdatei',
    fileTypeGeneric: 'Datei',
  },
  leadCard: {
    ariaForm: 'Kontaktformular',
    title: 'Hinterlassen Sie Ihre Kontaktdaten',
    nameLabel: 'Name',
    namePlaceholder: 'Ihr Name',
    phoneLabel: 'Telefon',
    phonePlaceholder: 'Ihre Telefonnummer',
    phoneError: 'Bitte geben Sie eine gültige Telefonnummer ein',
    submit: 'Absenden',
    submitting: 'Wird gesendet…',
    dismiss: 'Später',
    success: 'Danke! Unser Berater wird sich in Kürze bei Ihnen melden.',
  },
};
